import { IconHyperlink } from './IconHyperlink'

export default IconHyperlink
